import { FORM_METHOD_TYPES } from "../../../../stateCommon/consts";
import { getDefaultValue } from '@tencent/data-schema-core';
import { getObjectJSONString } from "../../../utils/code";
import { METHOD_TEMPLATES } from "../../../utils/consts";
import { deleteDbReadonlyFields } from "../../../../common/dbReadonlyFields";
export const init = options => {
  const {
    collection,
    isHttp
  } = options;
  const info = {
    args: [],
    type: FORM_METHOD_TYPES.init,
    tpl: METHOD_TEMPLATES.form.init,
    params: {
      assign: [],
      invoke: [{
        args: ['$query.id'],
        method: 'get',
        enabled: false
      }]
    }
  };
  const entitySchema = collection.entity;
  let code = '{}';
  if (entitySchema) {
    const data = getDefaultValue(entitySchema);
    if (!isHttp) {
      deleteDbReadonlyFields(data);
    }
    code = getObjectJSONString(data);
  }
  info.params.assign.push({
    key: 'formData',
    code
  });
  return info;
};
//# sourceMappingURL=init.js.map
